import { useState } from "react";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";
import { api } from "../../lib/api";
import { FadeUp, MaskLines } from "./Reveal";

export const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/newsletter", { email });
      toast.success("You're on the list. Welcome to MARKHOR.");
      setEmail("");
    } catch {
      toast.error("Please enter a valid email address.");
    } finally {
      setBusy(false);
    }
  };
  return (
    <section id="newsletter" className="bg-stone py-24 md:py-32" data-testid="newsletter-section">
      <div className="mx-auto grid max-w-[1600px] gap-10 px-5 md:px-10 lg:grid-cols-2 lg:items-end">
        <div>
          <p className="label-mono">The MARKHOR List</p>
          <MaskLines inView lines={["First to know.", "First to move."]} className="mt-4 font-display text-5xl font-light leading-[0.95] text-ink md:text-7xl" />
        </div>
        <FadeUp>
          <p className="mb-6 max-w-md text-sm text-graphite">New colors, limited drops and early access — delivered quietly, never too often.</p>
          <form onSubmit={submit} className="flex border-b border-ink" data-testid="newsletter-form">
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Your email address"
              data-testid="newsletter-email-input" className="w-full bg-transparent py-4 text-base text-ink outline-none placeholder:text-graphite" />
            <button disabled={busy} data-testid="newsletter-submit-button" className="group flex items-center gap-2 text-xs font-medium uppercase tracking-[0.2em] text-ink">
              {busy ? "…" : "Subscribe"} <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
            </button>
          </form>
        </FadeUp>
      </div>
    </section>
  );
};
